var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnxiety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 135 Q168 58 200 45 Q232 58 232 135 Q200 148 168 135 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 88,
    r: 3.5,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 88,
    r: 3.5,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 108 Q200 100 208 108",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175 50 L170 42 L178 44 L175 35 L182 40",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225 50 L230 42 L222 44 L225 35 L218 40",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190 30 L188 22 M200 27 L200 18 M210 30 L212 22",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240 100 Q270 110 280 130 Q290 150 280 170",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278 165 L280 170 L275 167",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245 180 Q245 200 260 210 Q275 220 275 240",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260,
    cy: 200,
    rx: 30,
    ry: 40,
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245 185 L250 185 M270 185 L275 185",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250 200 L255 198 M265 198 L270 200",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248 210 L252 212 M268 212 L272 210",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240 230 Q210 240 180 230 Q150 220 140 200 Q130 180 140 160 Q150 140 160 130",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158 135 L160 130 L163 134",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 180,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 140,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 220,
    r: 1,
    fill: "#fafcfb",
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 200,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnxiety);
export default __webpack_public_path__ + "static/media/anxiety.36e4d51e20ab8fa925be7f88f2841f52.svg";
export { ForwardRef as ReactComponent };